import { HttpInterceptorFn } from '@angular/common/http';

export const LanguageInterceptor: HttpInterceptorFn = (req, next) => {

  const currentLang =
    typeof window !== 'undefined'
      ? localStorage.getItem('lng') || 'en'
      : 'en';

  const modifiedRequest = req.clone({
    setHeaders: {
      'Accept-Language': currentLang
    }
  });

  return next(modifiedRequest);
};